import {Component, OnDestroy} from '@angular/core';
import {AppAuthService} from '@services/core/auth/app-auth.service';
import {TenantService} from '@services/core/tenant/tenant.service';
import {Subscription} from 'rxjs';
import {IconsDefinitionHelper} from '@shared/common/definition-helper';
import {Router} from "@angular/router";
import {AuthService} from "@app/areas/auth/services/auth.service";
import {LastViewedPatientService} from "@services/helpers/patient/last-viewed-patient.service";
import {LocalizeTextPipe} from '@shared/pipes/localize-text/localize-text.pipe';
import { AsyncPipe } from '@angular/common';
import {ProfilePictureComponent} from "@shared/components/profile-picture/profile-picture.component";
import {IconComponent} from "@shared/components/icon/icon.component";

@Component({
  selector: 'app-login-subj-bubble',
  templateUrl: './login-subj-bubble.component.html',
  styleUrls: ['./login-subj-bubble.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    LocalizeTextPipe,
    ProfilePictureComponent,
    IconComponent
]
})
export class LoginSubjBubbleComponent extends IconsDefinitionHelper implements OnDestroy {
  showAccountBubble = false;
  private subs: Subscription[] = [];

  constructor(
    public appAuthService: AppAuthService,
    public tenantService: TenantService,
    private router: Router,
    public authService: AuthService,
    private lastViewedService: LastViewedPatientService,
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  logout(): void {
    this.tenantService.clear();
    this.appAuthService.logout().then();
    this.authService.logout();
    this.lastViewedService.setPatientId(null);

    this.navigateToLogin();
  }

  private navigateToLogin(): void {
    this.router.navigate(['/account/login']).then();
  }

  /**
   * Toggling the show account bubble
   */
  toggleShowAccountBubble(): void {
    this.showAccountBubble = !this.showAccountBubble;
    if (this.showAccountBubble) {
      document.body.addEventListener('click', this.onClickAnyWhereHide, true);
    }
  }

  /**
   * On click anywhere event, should only be instantiated if the account bubble is being opened
   */
  private onClickAnyWhereHide = (e) => {
    const ignoreElements = ['A', 'SPAN', 'BUTTON'];

    const clickedIgnoreItem =
      e.target.classList.contains('account-icon') ||
      ignoreElements.includes(e.target.nodeName);

    if (!clickedIgnoreItem) {
      this.showAccountBubble = false;
      document.body.removeEventListener(
        'click',
        this.onClickAnyWhereHide,
        true
      );
    }
  };
}
